
import { Map, List } from 'immutable'
import moment from 'moment'


/** Produces a new request from the given request, with a leg added.
 * Minimal pre-population is performed (dates, routing).
 */
const addNewLeg = (req = Map()) => {

    const firstFrom = (req.get('required', List()).first() || Map()).get('from')
    const lastTo = (req.get('required', List()).last() || Map()).get('to')
    const routeStillOpen = firstFrom !== lastTo

    // Use last leg as 'template' if possible, otherwise use ours
    const a = (req.get('required', List()).last() ||
        Map.of(
            'isA', 'FlightRequirement',
            'maxStops', 0,
            'cabinClass', 'ECONOMY',
            'departureDate', moment().add(1, 'day').format('YYYY-MM-DD')
        ))
        .set('from', routeStillOpen
            ? lastTo
            : undefined)
        .set('to', routeStillOpen
            ? firstFrom
            : undefined)


    return req.update('required', (req = List()) =>
        req.push(a)
    )
}

export default addNewLeg


// WEBPACK FOOTER //
// ./src/ndc/request/addNewLeg.js